import React, { useEffect, useState } from 'react';
import { adminAPI } from '../services/api';
import { RefreshCw, AlertTriangle, AlertCircle, DoorOpen, Clock, WifiOff, Package, CreditCard, Info } from 'lucide-react';

const ALERT_CONFIG = {
  door_open: { icon: DoorOpen, color: '#ffb020' },
  check_box: { icon: Package, color: '#ff4466' },
  parcel_expired: { icon: Clock, color: '#ff4466' },
  draft_stale: { icon: Package, color: '#ffb020' },
  device_offline: { icon: WifiOff, color: '#ff4466' },
  refund_needed: { icon: CreditCard, color: '#ff4466' },
  unpaid_pickup: { icon: CreditCard, color: '#ffb020' },
  bookings_unused: { icon: Info, color: '#8789a0' },
};

export default function Alerts() {
  const [alerts, setAlerts] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [updated, setUpdated] = useState(null);

  const load = async () => {
    if (document.hidden && updated) return;
    try {
      const r = await adminAPI.alerts();
      setAlerts(r.data.alerts);
      setCount(r.data.count);
      setError('');
      setUpdated(new Date());
    } catch (e) {
      setError('Could not load alerts — the list below may be out of date.');
    }
    setLoading(false);
  };
  useEffect(() => {
    load();
    const interval = setInterval(load, 30000);
    return () => clearInterval(interval);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <div style={s.header}>
        <h1 style={s.title}>
          <AlertTriangle size={20} />
          Alerts {count > 0 && <span style={s.count}>{count}</span>}
        </h1>
        <button style={s.refreshBtn} onClick={load}><RefreshCw size={14} /> Refresh</button>
      </div>
      {error && <div style={s.error}>{error}</div>}
      {updated && <div style={{fontSize:11,color:'#8a8da4',marginBottom:10}}>Updated {updated.toLocaleTimeString()}</div>}
      {loading ? <div style={s.empty}>Loading...</div> :
       alerts.length === 0 && !error ? (
        <div style={s.noAlerts}>
          <div style={{fontSize:48,marginBottom:12}}>✅</div>
          <div style={{fontSize:16,fontWeight:600,color:'#8BC63E'}}>All clear!</div>
          <div style={{fontSize:13,color:'#8a8da4',marginTop:4}}>No active alerts</div>
        </div>
       ) : (
        <div style={s.list}>
          {alerts.map((a, i) => {
            const config = ALERT_CONFIG[a.type] || { icon: AlertCircle, color: '#8789a0' };
            const Icon = config.icon;
            return (
              <div key={i} style={{...s.alertCard, borderLeftColor: a.severity === 'critical' ? '#ff4466' : config.color}}>
                <div style={{...s.alertIcon, background:`${config.color}18`}}>
                  <Icon size={18} color={config.color} />
                </div>
                <div style={s.alertContent}>
                  <div style={s.alertTitle}>{a.title}</div>
                  <div style={s.alertDetail}>{a.detail}</div>
                  {a.timestamp && <div style={s.alertTime}>{a.timestamp.replace('T', ' ').slice(0, 16)}</div>}
                </div>
                <div style={{...s.alertSeverity, color: (a.severity === 'error' || a.severity === 'critical') ? '#ff4466' : '#ffb020'}}>
                  {a.severity}
                </div>
              </div>
            );
          })}
        </div>
       )}
    </div>
  );
}

const s = {
  header: { display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 },
  title: { fontSize:22, fontWeight:700, color:'#e4e5ed', display:'flex', alignItems:'center', gap:10 },
  count: { background:'#ff4466', color:'white', borderRadius:12, padding:'2px 10px', fontSize:13, fontWeight:700 },
  refreshBtn: { display:'flex', alignItems:'center', gap:6, padding:'8px 16px', background:'transparent', border:'1px solid #252733', borderRadius:8, color:'#8789a0', fontSize:12, cursor:'pointer' },
  empty: { padding:60, textAlign:'center', color:'#8a8da4', fontSize:14 },
  error: { background:'rgba(255,68,102,0.1)', border:'1px solid rgba(255,68,102,0.3)', borderRadius:8, padding:'10px 14px', color:'#ff4466', fontSize:13, marginBottom:12 },
  noAlerts: { background:'#0f1117', border:'1px solid #252733', borderRadius:14, padding:60, textAlign:'center' },
  list: { display:'flex', flexDirection:'column', gap:10 },
  alertCard: { display:'flex', alignItems:'center', gap:16, background:'#0f1117', border:'1px solid #252733', borderLeft:'4px solid', borderRadius:12, padding:'16px 20px' },
  alertIcon: { width:40, height:40, borderRadius:10, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 },
  alertContent: { flex:1 },
  alertTitle: { fontSize:14, fontWeight:700, color:'#e4e5ed', marginBottom:2 },
  alertDetail: { fontSize:13, color:'#8789a0' },
  alertTime: { fontSize:11, color:'#8a8da4', marginTop:4 },
  alertSeverity: { fontSize:11, fontWeight:700, textTransform:'uppercase', letterSpacing:1 },
};
